import type { ApiResponse } from '@abaninja/types';

import { apiClient } from '@abaninja/util-http-client';

export function createDeepBoxShareWithUser(userUuid: string) {
  return apiClient.post<ApiResponse<never>>('/deepcloud/v1/deepbox/shares', { userUuid });
}
